<template>
  <div class="login">
    <div class="login-container" :class="{'vscodeshow': isVcode}">
      <div class="login-container-bg">
        <div class="login-container-bg1">
          <template v-if="!quickLogin">
            <div class="login-logo">
              <img class="ll-img" src="../assets/logo1.png" alt="" />
              <div class="ll-text">管理员认证</div>
            </div>
            <el-form class="loginform" ref="form" :rules="rules" :model="form">
              <el-form-item label="账号" prop="mobile">
                <el-input @keyup.enter.native="onSubmit('form')" placeholder="账号" v-model.trim="form.mobile"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input @keyup.enter.native="onSubmit('form')" type="password" placeholder="密码" v-model.trim="form.password" show-password></el-input>
              </el-form-item>

              <el-form-item v-if="isVcode" prop="vcode" label="验证码" style="position: relative">
                <el-input @keyup.enter.native="onSubmit('form')" placeholder="验证码" v-model.trim="form.vcode"></el-input>
                <div class="sendcode">
                  <el-button v-if="lastTime <= 0" @click="getVcode" type="text">发送验证码</el-button>
                  <el-button v-else class="text-center" type="text">{{ lastTime }}秒</el-button>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button style="width:100%;height:45px;font-size:18px;margin-top:15px;" type="primary" @click="onSubmit('form')">确定</el-button>
              </el-form-item>
            </el-form>
          </template>
          <template v-if="quickLogin">
            <div class="quick-login">
              <el-button class="login-btn" type="primary" @click="onQuickSubmit">进入直播监考</el-button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="showtask" class="test-btn">
       <el-link style="margin-right: 15px;" @click="onOpenTest">进入压测</el-link>
       <!-- <el-link @click="onOpenTest">继续压测</el-link> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      quickLogin: false,
      collegeId: '',
      isVcode: false,
      lastTime: 0,
      form: {
        mobile: '',
        password: '',
        vcode: '',
      },
      rules: {
        mobile: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      taskTimer: null,
      showtask: false
    }
  },
  created() {
    this.checkQuickLogin()
    if (this.$route.query.vcode || window.localStorage.getItem('isVcode')) {
      this.$utils.$localStorage.set('isVcode', 1)
      this.isVcode = true
    } else {
      window.localStorage.removeItem('isVcode')
    }
    const collegeId = window.localStorage.getItem('collegeId')
    if (collegeId) {
      this.$router.push('/login')
      return
    }
    this.initConnect()
  },
  methods: {
    // 判断是否是快捷登录
    checkQuickLogin() {
      // ?collegeId=S0NdscHd99fa84e36384f8d9025d963c6484
      const { query } = this.$route
      const collegeId = this.$utils.$localStorage.get('defaultCollegeId')
      if (query.collegeId || collegeId) {
        this.collegeId = query.collegeId || collegeId
        this.$utils.$localStorage.set("defaultCollegeId", this.collegeId)
        this.quickLogin = true
      } else {
        this.$utils.$localStorage.remove('defaultCollegeId')
        this.collegeId = ''
        this.quickLogin = false
      }
      const useMainAssitName = this.$utils.$localStorage.get('useMainAssitName')
      if (query.useMainAssitName || useMainAssitName) {
        this.$utils.$localStorage.set("useMainAssitName", query.useMainAssitName || useMainAssitName)
      } else {
        this.$utils.$localStorage.remove('useMainAssitName')
      }
    },
    async getVcode() {
      if (this.form.mobile && /^1\d{10}$/.test(this.form.mobile)) {
        const codeData = await this.$HTTP.ApiLogin.POSTsendVcode({
          mobile: this.form.mobile,
          messageType: 'login',
        })
        this.$message.success('验证码发送成功！')
        if (codeData) {
          this.form.vcode = codeData
        }
        this.lastTime = 60
        const intTime = setInterval(() => {
          this.lastTime = this.lastTime - 1
          if (this.lastTime <= 0) {
            clearInterval(intTime)
          }
        }, 1000)
      } else {
        this.$message.error('请输入合法的手机号')
      }
    },
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            let res
            if (!this.isVcode) {
              res = await this.$HTTP.ApiLogin.POSTmonitorAdminLogin({
                ...this.form,
              })
            } else {
              res = await this.$HTTP.ApiLogin.POSTmonitorAdminLoginByVcode({
                ...this.form,
              })
            }
            window.localStorage.setItem('password', this.form.password)
            window.localStorage.setItem('collegeId', res.collegeId)
            this.$utils.$localStorage.set("AppSource", 'live_monitor');
            this.$router.push('/login')
          } else {
            return false
          }
        } catch (error) {
          console.log(error, 'error')
        }
      })
    },
    async onQuickSubmit() {
      window.localStorage.setItem('password', 'password')
      window.localStorage.setItem('collegeId', this.collegeId)
      this.$utils.$localStorage.set("AppSource", 'live_monitor');
      this.$router.push('/login')
    },
    async onOpenTest() {
      const res = await this.$HTTP.ApiLogin.GETStartcurrenttask()
      if (res && res.requiredTaskCode) {
        await this.$prompt('请输入压测码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: (val) => {
            const val1 = val || ''
            let result = false
            if (!(/^\d{8}$/.test(val1.trim()))) {
              result = '请输入正确8位压测码！'
            } else {
              result = true
            }
            return result
          },
          closeOnPressEscape: false,
          closeOnClickModal: false,
          beforeClose: async (action, instance) => {
            if (action == 'confirm') {
              const param = {taskCode: instance.inputValue.trim()}
              const res1 = await this.$HTTP.ApiLogin.GETStartcurrenttask(param)
              if (res1.taskId) {
                const taskData = this.$utils.$localStorage.get("taskData");
                const result = {...taskData, ...res1}
                this.$utils.$localStorage.set("taskData", result);
                instance.close()
                this.$router.push('/press-test')
              }
            } else {
              instance.close()
            }
          }
        })
      } else {
        if (res.taskId) {
          const taskData = this.$utils.$localStorage.get("taskData");
          const result = {...taskData, ...res}
          this.$utils.$localStorage.set("taskData", result);
          this.$router.push('/press-test')
        }
      }
    },
    initConnect () {
      const _this = this
      if (window.core) {
        const connectStressTestToken = function(timestamp, token) {
          _this.getTestToken(timestamp, token)
        }
        window.core.stressTestToken.connect(connectStressTestToken);
        window.core.getStressTestToken()
        this.$once("hook:beforeDestroy", () => {
          // 销毁页面后取消订阅，避免多次订阅
          window.core.stressTestToken.disconnect(connectStressTestToken);
        });
      } else {
        setTimeout(() => {
          _this.initConnect()
        }, 1000)
      }
    },
    getTestToken(timestamp, token) {
      console.log(timestamp, token, 'timestamp, token')
      if (timestamp && token) {
        this.$utils.$localStorage.set("taskToken", {timestamp, token});
        this.getCurrentTask()
      }
    },
    async getCurrentTask() {
      const _this = this
      this.clearTimerHeart()
      const res1 = await this.$HTTP.ApiLogin.GETcurrenttask()
      if (res1 && res1.taskId) {
        this.showtask = true
        this.$utils.$localStorage.set("taskData", res1);
        return
      } else {
        this.showtask = false
      }
      const taskTimer = setInterval(async () => {
        const res = await this.$HTTP.ApiLogin.GETcurrenttask()
        if (res && res.taskId) {
          this.showtask = true
          this.$utils.$localStorage.set("taskData", res);
        } else {
          this.showtask = false
        }
      }, 30000);
      this.taskTimer = taskTimer
      this.$once("hook:beforeDestroy", () => {
        // 销毁页面后取消订阅，避免多次订阅
        _this.clearTimerHeart()
      });
      this.$once("hook:destroyed", () => {
        // 销毁页面后取消订阅，避免多次订阅
        console.log('destroyed,1111111111')
        _this.clearTimerHeart()
      });
    },
    clearTimerHeart() {
      if (this.taskTimer) {
        clearInterval(this.taskTimer);
        this.taskTimer = null
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  min-width: 440px;
  display: flex;
  justify-content: center;
  align-items: center;
  &-container {
    width: 440px;
    height: 440px;
    border: 2px solid rgba(112, 112, 112, 0.6);
    border-radius: 16px;
    background-color: rgba(37, 43, 77, 1);
    box-shadow: 0px 14px 32px rgba(0, 8, 29, 0.16);
    &-bg1 {
      width: 100%;
      height: 100%;
      background: url("../assets/img_logo.png") no-repeat bottom right;
      background-size: 60%;
      padding: 30px 50px;
    }
    &-bg {
      width: 100%;
      height: 100%;
      background: url("../assets/img_in.png") no-repeat left top;
      background-size: 100%;
    }
    .login-logo {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .ll-img {
        width: 32px;
        height: 42px;
      }
      .ll-text {
        // width: 48px;
        // height: 32px;
        font-size: 24px;
        color: #ffffff;
        position: relative;
        margin-left: 30px;
        &::after {
          position: absolute;
          content: "";
          width: 1px;
          height: 21px;
          top: 50%;
          left: -15px;
          transform: translateY(-50%);
          background: #ccc;
        }
      }
    }
    .loginform {
      width: 340px;
      .sendcode {
        text-align: center;
        width: 102px;
        position: absolute;
        right: 11px;
        bottom: 0px;
        cursor: pointer;
      }

      .sendcode::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 20px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: #d9d9d9;
      }
    }
  }
  .vscodeshow {
    height: 500px;
  }
}
.test-btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 15px 30px;
  display: flex;
  justify-content: flex-end;
}
.test-btn::v-deep .el-link.el-link--default:hover {
  color: #fff;
}
.test-btn::v-deep .el-link {
  color: #fff;
}
.test-btn::v-deep .el-link.el-link--default:after, .el-link.el-link--primary.is-underline:hover:after, .el-link.el-link--primary:after {
  border-color: #fff;
}
.quick-login {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-btn {
  border: none;
  color: white;
  height: 70px;
  width: 260px;
  position: absolute;
  border-radius: 70px;
  top: calc(50% - 60px);
  font-size: 20px;
  transition: all 0.2s;
}
</style>
<style>
.loginform .el-form-item__label {
  color: #fff !important;
}
</style>
